import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as actions from "../../actions";
import { useNavigate } from "react-router-dom";

export default () => {

  const moduleName = `auth/logout`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(actions.list(moduleName));
  }, []);

  useEffect(() => {
    if (appReducer.auth_logout_list != undefined) {
      localStorage.removeItem("token");
      navigate("/");
    }
  }, [appReducer.auth_logout_list]);

  return <></>;
};
